import { useEffect } from "react";
import Lenis from "lenis";

// Smooth momentum scrolling. Anchor links are intercepted for eased scroll.
export default function useLenis() {
    useEffect(() => {
        const prefersReduced = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
        ).matches;
        if (prefersReduced) return;

        const lenis = new Lenis({
            duration: 1.25,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });

        let rafId;
        function raf(time) {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        }
        rafId = requestAnimationFrame(raf);

        // Expose for programmatic scrolls (e.g. logo → top) without touching the URL.
        window.__lenis = lenis;

        const onClick = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const id = a.getAttribute("href");
            if (id.length < 2) return;
            const el = document.querySelector(id);
            if (!el) return;
            e.preventDefault();
            lenis.scrollTo(el, { offset: -10, duration: 1.6 });
        };
        document.addEventListener("click", onClick);

        return () => {
            cancelAnimationFrame(rafId);
            document.removeEventListener("click", onClick);
            delete window.__lenis;
            lenis.destroy();
        };
    }, []);
}
